import React, { useEffect, useRef, useState } from 'react';
import { CheckoutButton } from './CheckoutButton';
import { LIGHTBOX_EVENT } from './Lightbox/Lightbox';
import { BRAND } from '../data/collection';
import { PRICE } from '../data/checkout';

/** Elements that make the bar redundant while they are on screen. */
const HIDE_WHEN_VISIBLE = ['offer-price', 'offer-cta', 'final-cta', 'site-footer'];
const inView = (id: string) => {
  const el = document.getElementById(id);
  if (!el) return false;
  const rect = el.getBoundingClientRect();
  return rect.top < window.innerHeight && rect.bottom > 0;
};

/** True once the visitor has reached the main offer (its top has entered the screen). */
const reachedOffer = () => {
  const offer = document.getElementById('oferta');
  return offer ? offer.getBoundingClientRect().top < window.innerHeight : false;
};

/**
 * Mobile-only purchase bar. Appears only after reaching the main offer and hides
 * while another buy button, the footer or the page viewer is on screen.
 */
export function StickyBuyBar() {
  const [visible, setVisible] = useState(false);
  const lightboxOpen = useRef(false);
  useEffect(() => {
    let frame = 0;
    const update = () => {
      frame = 0;
      setVisible(reachedOffer() && !lightboxOpen.current && !HIDE_WHEN_VISIBLE.some(inView));
    };
    const schedule = () => {
      if (!frame) frame = window.requestAnimationFrame(update);
    };
    const onLightbox = (event: Event) => {
      lightboxOpen.current = Boolean((event as CustomEvent<boolean>).detail);
      schedule();
    };
    update();
    window.addEventListener('scroll', schedule, {
      passive: true
    });
    window.addEventListener('resize', schedule);
    window.addEventListener(LIGHTBOX_EVENT, onLightbox);
    return () => {
      if (frame) window.cancelAnimationFrame(frame);
      window.removeEventListener('scroll', schedule);
      window.removeEventListener('resize', schedule);
      window.removeEventListener(LIGHTBOX_EVENT, onLightbox);
    };
  }, []);
  return <div aria-hidden={!visible} className={`fixed inset-x-3 z-40 transition-[transform,opacity] duration-[250ms] md:hidden ${visible ? 'translate-y-0 opacity-100' : 'pointer-events-none translate-y-[calc(100%+24px)] opacity-0'}`} style={{
    bottom: 'calc(12px + env(safe-area-inset-bottom))',
    transitionTimingFunction: 'cubic-bezier(0.23, 1, 0.32, 1)'
  }} data-id="element-291" data-mp="2f1muqudpq0jm">
      <div className="flex items-center justify-between gap-3 rounded-[18px] bg-paper py-2 pl-4 pr-2 shadow-[0_18px_40px_-14px_rgba(52,52,49,0.45)] ring-1 ring-ivory-line" data-id="element-292" data-mp="2y07lumflt5x9">
        <p className="min-w-0 leading-tight" data-id="element-293" data-mp="37qkbuu66tras">
          <span className="block truncate font-serif text-[0.95rem] font-semibold italic text-coral-ink" data-id="element-294" data-mp="37p8xk0f4915f">{BRAND.name}</span>
          <span className="sr-only" data-id="element-295" data-mp="32s90ug45paqz"> · </span>
          <span className="mt-0.5 block text-[1.15rem] font-extrabold text-graphite" data-id="element-296" data-mp="3gqp7k720r194">
            {PRICE.label} <span className="text-[0.8rem] font-semibold text-graphite-soft" data-id="element-297" data-mp="3bsnp9ocf35yp">ARS</span>
          </span>
        </p>
        <CheckoutButton label="Comprar" size="sm" className="shrink-0" tabIndex={visible ? 0 : -1} data-id="element-298" data-mp="3vez17xeoavcu" />
      </div>
    </div>;
}